/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_New_Lot_TextInputs */

const vi_confirm_return_new_lot_text = /** @type {(inputs: Confirm_Return_New_Lot_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo lô mới`)
};

/**

* @param {Confirm_Return_New_Lot_TextInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_new_lot_text = /** @type {((inputs?: Confirm_Return_New_Lot_TextInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_New_Lot_TextInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_new_lot_text(inputs)
});